module.exports = __webpack_public_path__ + "static/2-before.b595939e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/full-size/2-before.jpg
// module id = 436
// module chunks = 221374088121123